import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import FinancingWizard from "./pages/FinancingWizard";
import Conferma from "./pages/Conferma";
import AdminDashboard from "./pages/AdminDashboard";
import PraticaDetail from "./pages/PraticaDetail";
import CustomerIntake from "./pages/CustomerIntake";

const AnimatedApp = () => {
  // Local development: skip loading/auth checks
  return (
    <Routes>
      <Route path="/" element={<FinancingWizard />} />
      <Route path="conferma" element={<Conferma />} />
      <Route path="admin" element={<AdminDashboard />} />
      <Route path="admin/pratica/:id" element={<PraticaDetail />} />
      <Route path="intake/:token" element={<CustomerIntake />} />
    </Routes>
  );
};

function FinPolis() {
  return (
    <AuthProvider>
      <AnimatedApp />
    </AuthProvider>
  );
}

export default FinPolis;
